import React, {useRef, useState} from 'react';
import {Controller, useForm} from 'react-hook-form';
import {Button} from 'primereact/button';
import {classNames} from 'primereact/utils';
import {Toast} from 'primereact/toast';
import {InputText} from "primereact/inputtext";
import axios from "axios";
import {Dialog} from "primereact/dialog";
import {Image} from "primereact/image";

const CmpInputArea = (props) => {
    const toast = useRef(null);
    const [dispApiDialog,setDisApiDialog] = useState(false)
    const [dispChIdDialog,setDisChIdDialog] = useState(false)

    const show = () => {
        toast.current.show({severity: 'success', summary: 'Form Submitted', detail: getValues('value')});
    };

    const defaultValues = {
        api_key: '',
        ch_id: ''
    };

    const {
        control,
        formState: {errors},
        handleSubmit,
        getValues,
        reset
    } = useForm({defaultValues});

    const onSubmit = (data) => {
        data.value && show();
        get_youtube_videos_data(data)

        reset();
    };

    const getFormErrorMessage = (name) => {
        return errors[name] ? <small className="p-error">{errors[name].message}</small> :
            <small className="p-error">&nbsp;</small>;
    };

    const get_youtube_videos_data = async(data) =>{
        let all_videos = []
        const url = "https://4yhuw9qsm8.execute-api.ap-northeast-1.amazonaws.com/prod/youtube/all_videos"
        // console.log(data)
        const params = {
            api_key:data.api_key,
            youtubech_id :data.ch_id
        }
        const response = await axios.get(url, {params})
            .catch((res)=>{
                // console.log(res)
                toast.current.show({severity:'error', summary: 'Error', detail:'API KeyもしくはチャンネルIDを確認してください。\n', life: 3000});
            })
        // const all_videos = response.data.all_videos.map((video)=> {
        //     return video.snippet
        // })
        // console.log(response)
        if(response !== undefined){
            all_videos = response.data
        }else{
            all_videos = []
        }

        props.setVideos(all_videos)
    }

    return (
        <div className={"flex-auto justify-content-center"}>
            <form onSubmit={handleSubmit(onSubmit)} className={"p-fluid"}>
                <Toast ref={toast}/>
                <div className={"flex justify-content-center align-items-center"}>
                    <Controller
                        name="api_key"
                        control={control}
                        rules={{required: 'APIキーは必須項目です。'}}
                        render={({field, fieldState}) => (
                            <>
                                <label htmlFor={field.name} className={classNames({'p-error': errors.value})}></label>
                                <span className="p-float-label m-3 w-24rem">
                                <InputText
                                    // inputId={field.name}
                                    value={field.value}
                                    // inputRef={field.ref}
                                    className={classNames({'p-invalid': fieldState.error})}
                                    onChange={(e) => field.onChange(e.target.value)}
                                    // onMouseOver={(e) => {
                                    //     console.log("aaa")
                                    // }}
                                />
                                <label htmlFor={field.name}>API Key</label>
                            </span>
                                {getFormErrorMessage(field.name)}
                            </>
                        )}
                    />
                    <i className={"pi pi-question-circle"} onClick={()=>setDisApiDialog(true)}/>
                </div>
                <div className={"flex justify-content-center align-items-center"}>
                    <Controller
                        name="ch_id"
                        control={control}
                        rules={{required: 'YoutubeCh IDは必須項目です。'}}
                        render={({field, fieldState}) => (
                            <>
                                <label htmlFor={field.name} className={classNames({'p-error': errors.value})}></label>
                                <span className="p-float-label m-3 w-24rem">
                                <InputText
                                    // inputId={field.name}
                                    value={field.value}
                                    // inputRef={field.ref}
                                    className={classNames({'p-invalid': fieldState.error})}
                                    onChange={(e) => field.onChange(e.target.value)}/>
                                <label htmlFor={field.name}>YoutubeCh ID</label>
                            </span>
                                {getFormErrorMessage(field.name)}
                            </>
                        )}
                    />
                    <i className={"pi pi-question-circle"} onClick={()=>setDisChIdDialog(true)}/>
                </div>
                <div className={"flex justify-content-center align-items-center"}>
                    <Button className={"m-2 w-24rem"} label="Submit" type="submit" icon="pi pi-check"/>
                </div>
            </form>
            <Dialog header={"APIKey ヘルプ"} onHide={()=>{setDisApiDialog(false)}} closable visible={dispApiDialog}>
                <p>APIKeyの取得は、下記を参考にするとわかりやすいかもしれません。</p>
                <p>参考URL:<a href={"https://kotatsu.tv/blog/2022-01-11-gcp-youtube-api-key/"} target={"_blank"} rel="noreferrer">https://kotatsu.tv/blog/2022-01-11-gcp-youtube-api-key/</a></p>
            </Dialog>
            <Dialog header={"チャンネルID ヘルプ"} onHide={()=>{setDisChIdDialog(false)}} closable visible={dispChIdDialog}>
                <p>検索したいチャンネルをブラウザで開いて、URLの下記の赤枠で囲まれている部分がチャンネルIDです。</p>
                <Image src={"./images/youtubech_id_image.png"}/>
                <p>UCXXXXXXXX もしくは　@XXXXXXのようなIDが使用可能です。</p>
            </Dialog>
        </div>

    )
}

export default CmpInputArea